import React, {FC, memo, ReactElement} from "react";
import css from "./LayoutTableWrapper.less";

type LayoutTableWrapperProps = {
    children?: ReactElement;
};

const LayoutTableWrapper: FC<LayoutTableWrapperProps> = ({children = null}) => {
    return <div className={css.root}>{children}</div>;
};

export default memo(LayoutTableWrapper);
